import * as React from 'react';
import { connect } from 'react-redux';
import { Button, ButtonProps } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Selectors
import {
    makeSelectQueryStringParamsExist
    // @ts-ignore
} from 'workspaces/react-router-selectors';

interface OwnProps {
    params: {
        [param: string]: any;
    };
    children: React.ReactNode;
    buttonProps?: ButtonProps;
    ignoreActive?: boolean;
}

interface ConnectedProps {
    active?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

/**
 * A button component that adds params to qs when clicked.
 */
export class QueryStringButton extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        const { params } = this.props;
        this.props.updateQueryString(params);
    };

    render(): React.ReactElement | null {
        const { children, buttonProps, active, ignoreActive } = this.props;
        return (
            <Button
                {...(buttonProps || {
                    circular: true,
                    secondary: true,
                    size: 'small'
                })}
                onClick={this.handleClick}
                active={ignoreActive ? false : active}
            >
                {children}
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    active: (state: any, props: any): boolean =>
        makeSelectQueryStringParamsExist(props.params)(state, props)
});

export default connect(mapStateToProps, { updateQueryString })(
    QueryStringButton
);
